import EventTargetPolyfill from '@mattkrick/event-target-polyfill'

if (!window.EventTarget) {
    // Add the polyfill for iOS 12 - 14. Reference: https://go-jek.atlassian.net/wiki/spaces/EP/pages/2515574996/Clickstream+Web+Integration+Manual#Send-events-in-iOS-12---14
    window.EventTarget = EventTargetPolyfill
}
